import { render, staticRenderFns } from "./EditContractSubject.vue?vue&type=template&id=460b2e36&"
import script from "./EditContractSubject.vue?vue&type=script&lang=js&"
export * from "./EditContractSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports